module.exports = __webpack_public_path__ + "static/edge-of-the-universe-aee1932b0798641591d74c2aa00e3a36.jpg";